import React, { useState, useEffect } from "react";
import CameraCapture from "./CameraCapture";
import ResultBox from "./ResultBox";
import './app-scan.css';

export default function AppScan() {
  const [step, setStep] = useState("intro");
  const [result, setResult] = useState(null);
  const [capturedImage, setCapturedImage] = useState(null); // ✅ thêm state
  const [isPortrait, setIsPortrait] = useState(
    typeof window !== "undefined" ? window.matchMedia("(orientation: portrait)").matches : false
  );

  useEffect(() => {
    if (typeof window === "undefined") return;
    const mq = window.matchMedia("(orientation: portrait)");
    const handle = (e) => setIsPortrait(e.matches);
    // support both addEventListener and legacy addListener
    if (mq.addEventListener) mq.addEventListener("change", handle);
    else mq.addListener(handle);
    // initial
    setIsPortrait(mq.matches);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener("change", handle);
      else mq.removeListener(handle);
    };
  }, []);

  const handleCaptureComplete = (analysis) => {
    setResult(analysis);
    setCapturedImage(analysis.capturedImage); // ✅ lưu ảnh đã chụp
    setStep("result");
  };

  const handleBackCamera = () => {
    setResult(null);
    setCapturedImage(null);
    setStep("camera");
  };

  const handleBack = () => {
    setResult(null);
    setStep("intro");
  }
    return (
      <div style={{ backgroundColor: "#000", minHeight: '100vh' }}>
        {isPortrait && (
          <div className="rotate-overlay" role="dialog" aria-live="polite">
            <div className="rotate-box">
              <div className="rotate-icon" aria-hidden>↻</div>
              <div className="rotate-text">Vui lòng xoay ngang màn hình để xem</div>
              <div className="rotate-sub">(Xoay thiết bị sang chế độ ngang)</div>
            </div>
          </div>
        )}
        {step === "intro" && (
          <div className="scan-intro-bg" onClick={() => setStep("camera")}>
          </div>
        )}

        {step === "camera" && <CameraCapture onComplete={handleCaptureComplete} />}

        {step === "result" && (
          <div className="result-container">
            <ResultBox result={result} error={result?.error} capturedImage={capturedImage} onBack={handleBackCamera}/>
          </div>
        )}
      </div>
    );
  }
